// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/wallet.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'wallet',
  version: 'outline',
  paths: [
    {
      d: 'M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 9m18 0V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v3',
    },
  ],
}
